import { createSlice } from "@reduxjs/toolkit";
import { UploadFileStatusEnum } from "../utils/uwp";

export const uwp = createSlice({
  name: "uwp",
  initialState: {
    appVersion: "",
    enableRemoteCode: false,
    uploadStatus: UploadFileStatusEnum.Normal,
    uploadProgress: 0,
    uploadMsg: "",
    enableSync: false,
    syncUploadFileContent: false,
  },
  reducers: {
    updateUploadStatus: (state, action) => {
      const { status, percentage, msg } = action.payload;
      state.uploadStatus = status;
      state.uploadProgress = percentage;
      state.uploadMsg = msg;

      switch (status) {
        case UploadFileStatusEnum.PackageStart:
        case UploadFileStatusEnum.GetUploadLinkStart:
        case UploadFileStatusEnum.UploadFileStart:
        case UploadFileStatusEnum.Canceling:
          state.enableSync = true;
          break;
        default:
          state.enableSync = false;
      }
    },
    enableSync: (state) => {
      state.enableSync = true;
    },
    disableSync: (state) => {
      state.enableSync = false;
    },
    triggerSyncUploadFileContent: (state) => {
      state.syncUploadFileContent = true;
    },
    resetSyncUploadFileContent: (state) => {
      state.syncUploadFileContent = false;
    },
    setAppVersion: (state, action) => {
      state.appVersion = action.payload;
    },
    setEnableRemoteCode: (state, action) => {
      state.enableRemoteCode = action.payload;
    },
  },
});

export default uwp.reducer;
